import React from "react";

const CenterCirle = () => {
  return (
    <div
      style={{ boxShadow: "0px 8.82px 17.63px 0px rgba(216, 218, 229, 0.8)" }}
      className=" bg-[#FAFBFF] pr-[10.77px] pl-[11.69px] pt-[14.6px] pb-[18.42px] rounded-full "
    >
      <h3 className=" font-inter font-bold text-lg text-center text-[#0049C6]">
        82.3%
      </h3>
      <p className=" font-inter font-normal text-xs text-center text-[#0049C6]">
        Total
      </p>
    </div>
  );
};

export default CenterCirle;
